<form [formGroup]="form" (ngSubmit)="onSave()" class="formgrid grid">

  <div class="col-8">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
    <input pInputText formControlName="name" type="text" class="inputfield w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('name')?.invalid && form.get('name')?.touched }"
      placeholder="Funerals" />
    <small class="block text-500 mt-1">
      The group's label in the menu (or the column heading in the footer). A group with a single
      link named the same as the group shows as one plain link.
    </small>
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Shown in</h3>
    <p-dropdown formControlName="location" [options]="locationOptions" styleClass="w-full" appendTo="body"></p-dropdown>
  </div>

  <div class="col-12 flex align-items-center mt-2" *ngIf="form.get('location')?.value === 'header'">
    <p-inputSwitch class="flex-initial" formControlName="showRegions"></p-inputSwitch>
    <span class="ml-2 text-700">
      Add the live list of regions, grouped by state
      <small class="block text-500">
        Built from the published Regions, so it stays right on its own — new regions appear here
        without anyone editing this menu. Shown after any sections you add below.
      </small>
    </span>
  </div>

  <div class="col-12">
    <div class="flex align-items-center justify-content-between border-bottom-1 border-200">
      <h3 class="text-500 my-2">Links</h3>
      <button pButton pRipple type="button" label="Add link" icon="pi pi-plus"
        class="p-button-text p-button-sm" (click)="addItem()"></button>
    </div>

    <small class="block text-500 mb-3">
      Give a link sub-links to turn it into a headed section — that's how the state groupings in
      the Locations menu look. A row with sub-links becomes the heading and stops being clickable.
      <span *ngIf="form.get('location')?.value === 'footer'" class="block mt-1">
        In the footer the heading shows as a small label above its sub-links, inside the column.
      </span>
    </small>

    <div *ngFor="let it of items; let i = index; let last = last" class="border-1 border-200 border-round p-2 mb-2">
      <div class="flex gap-2 align-items-start">
        <input pInputText type="text" class="inputfield flex-1" [(ngModel)]="it.label"
          [ngModelOptions]="{ standalone: true }" placeholder="Cremation" />
        <app-target-input *ngIf="!it.children.length" class="flex-1"
          [(ngModel)]="it.target" [ngModelOptions]="{ standalone: true }"
          (pageSelected)="applyPickedLabel(it, $event)" placeholder="/cremation"></app-target-input>
        <!-- Replaced outright rather than disabled: a greyed input with a
             changed placeholder was too quiet, and people only noticed the row
             had become a heading after closing and reopening the dialog.
             Sized to its own text (no flex-1) — stretched across half the row
             it wrapped onto two lines and read like another input. -->
        <span *ngIf="it.children.length" class="flex align-items-center gap-2 text-600 text-xs white-space-nowrap px-2"
          pTooltip="The sub-links below are the links — this row is just their heading" tooltipPosition="top">
          <i class="pi pi-list" style="font-size: 0.7rem"></i>
          Section heading — not a link
        </span>
        <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
          [disabled]="i === 0" (click)="moveItem(i, -1)" title="Move up"></button>
        <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
          [disabled]="last" (click)="moveItem(i, 1)" title="Move down"></button>
        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger"
          (click)="removeItem(i)" title="Remove"></button>
      </div>

      <!-- Sub-links: this row becomes a headed section in the dropdown. -->
      <div *ngIf="it.children.length" class="pl-4 mt-2 border-left-2 border-200">
        <div *ngFor="let c of it.children; let ci = index; let clast = last" class="flex gap-2 align-items-start mb-2">
          <input pInputText type="text" class="inputfield flex-1" [(ngModel)]="c.label"
            [ngModelOptions]="{ standalone: true }" placeholder="Sydney" />
          <app-target-input class="flex-1" [(ngModel)]="c.target"
            [ngModelOptions]="{ standalone: true }"
            (pageSelected)="applyPickedLabel(c, $event)" placeholder="/nsw/sydney"></app-target-input>
          <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="ci === 0" (click)="moveChild(it, ci, -1)"></button>
          <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="clast" (click)="moveChild(it, ci, 1)"></button>
          <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="removeChild(it, ci)"></button>
        </div>
      </div>

      <button pButton pRipple type="button" [label]="it.children.length ? 'Add another sub-link' : 'Add sub-links'"
        icon="pi pi-plus" class="p-button-text p-button-sm mt-1" (click)="addChild(it)"
        [pTooltip]="it.children.length ? '' : 'Turns this row into a heading — its own link is replaced by the sub-links'"
        tooltipPosition="top"></button>
    </div>

    <p *ngIf="!items.length" class="text-500 text-sm">No links yet — add at least one.</p>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-3">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" (click)="onCancel()"></button>
    <button pButton pRipple type="submit" label="Save" icon="pi pi-check"></button>
  </div>

</form>
